<template>
  <div class="container">
    <div class="jiance_main">
      <iframe
        id="iframeContain"
        name="iframeContain"
        seamless
        scrolling="no"
        :src="'../../../static/charge/login.html?u='+encodeURIComponent('福瑞达光电运营')+'&p=123456'"
      >
        您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
     </iframe>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      title: ''
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.container {
  width: 100%;
  height:100%;
  position: relative;
  background:url('../../assets/datacount.png') no-repeat;
  background-size: cover;
  overflow: hidden;
}
.jiance_main{
  position: absolute;
  top:-50px;
  left:0;
  right:0;
  bottom:0;
  overflow: hidden;
}

#iframeContain{
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin:0;
}
</style>